import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { EBACCOUNTDEPOSITS, REQUESTINPUT } from "app/shared/services/services-model.type";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import { getIntRate } from "../../term-deposit-utils/term-deposit.utils";
import {
  FetchTermDepositTopUpAuthorizationRequest,
  FetchTermDepositTopUpConfirmRequest,
  FetchTermDepositTopUpCreateRequest,
} from "../reducer/types";

export const fetchTermDepositListTopUpService = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_LIST_TOP_UP);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

const createTopUpParam = (action: FetchTermDepositTopUpCreateRequest) => {
  const data: EBACCOUNTDEPOSITS = {
    SERVICE_CODE: ServiceCode.TERM_DEPOSIT_TOPUP,
    CREDIT_ACCOUNT_NUMBER: action.payload?.ACCOUNT_CREDIT?.ACCOUNTNO,
    CREDIT_ACCOUNT_TYPE: action.payload?.ACCOUNT_CREDIT?.ACCOUNTTYPE,
    CREDIT_BANK_NAME: "PVcomBank",
    DEBIT_ACCOUNT_NUMBER: action.payload?.ACCOUNT_DEBIT?.ACCOUNTNO,
    DEBIT_ACCOUNT_TYPE: action.payload?.ACCOUNT_DEBIT?.ACCOUNTTYPE,
    DEBIT_ACCOUNT_CURRENCY: action.payload?.ACCOUNT_DEBIT?.CURRENCYCODE || "VND",
    TRANSACTION_AMOUNT: action.payload?.AMOUNT,
    PREFIX_DESCRIPTION: "TOPUP TERM DEPOSIT",
    TRANSACTION_DESCRIPTION: "TOPUP TERM DEPOSIT",
  };
  return data;
};

const confirmTopUpParam = (action: FetchTermDepositTopUpConfirmRequest) => {
  const dataCreate = store.getState().termDepositTopUp.dataCreate;
  const data: EBACCOUNTDEPOSITS = {
    ...action.payload?.EBACCOUNT_DEPOSITS,
    SERVICE_CODE: ServiceCode.TERM_DEPOSIT_TOPUP,
    TRANSACTION_AMOUNT: dataCreate?.AMOUNT,
    CREDIT_ACCOUNT_NUMBER: dataCreate?.ACCOUNT_CREDIT?.ACCOUNTNO,
    CREDIT_ACCOUNT_TYPE: dataCreate?.ACCOUNT_CREDIT?.ACCOUNTTYPE,
    CREDIT_BANK_CODE: dataCreate?.ACCOUNT_CREDIT?.BANK_CODE,
    CREDIT_BANK_NAME: "PVcomBank",
    CREDIT_BRANCH_CODE: dataCreate?.ACCOUNT_CREDIT?.BRANCH_CODE,
    CREDIT_BRANCH_NAME: dataCreate?.ACCOUNT_CREDIT?.BRANCH_NAME,
    CREDIT_AMOUNT: dataCreate?.AMOUNT,

    DEBIT_ACCOUNT_NUMBER: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO,
    DEBIT_ACCOUNT_TYPE: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTTYPE,
    DEBIT_ACCOUNT_NAME: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNAME,
    DEBIT_BANK_CODE: dataCreate?.ACCOUNT_DEBIT?.BANK_CODE,
    DEBIT_BANK_NAME: dataCreate?.ACCOUNT_DEBIT?.BANK_NAME,
    DEBIT_BRANCH_CODE: dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE,
    DEBIT_BRANCH_NAME: dataCreate?.ACCOUNT_DEBIT?.BRANCH_NAME,
    DEBIT_AMOUNT: dataCreate?.AMOUNT,
    DEBIT_ACCOUNT_CURRENCY: dataCreate?.ACCOUNT_DEBIT?.CURRENCYCODE || "VND",

    PREFIX_DESCRIPTION: "TOPUP TERM DEPOSIT",
    TRANSACTION_DESCRIPTION: "TOPUP TERM DEPOSIT",
  };
  if (data.INTEREST_RATE?.length) {
    data.INTEREST_RATE = getIntRate(data.INTEREST_RATE);
  }
  return data;
};

export const fetchTermDepositTopUpCreateService = async (actionRq: FetchTermDepositTopUpCreateRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_TOP_UP_CREATE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const ebAccountDeposit = createTopUpParam(actionRq);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: ebAccountDeposit,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositTopUpConfirmService = async (actionRq: FetchTermDepositTopUpConfirmRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_TOP_UP_CONFIRM);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const ebAccountDeposit = confirmTopUpParam(actionRq);
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    EBACCOUNT_DEPOSITS: ebAccountDeposit,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTermDepositTopUpAuthService = async (actionRq: FetchTermDepositTopUpAuthorizationRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.TERM_DEPOSIT_TOP_UP_AUTH);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    AUTHORIZE_CODE: actionRq.code,
    CHALLENGE_ID: actionRq.payload?.CHALLENGE_ID,
    EBACCOUNT_DEPOSITS: {
      ...actionRq.payload?.EBACCOUNT_DEPOSITS,
      PREFIX_DESCRIPTION: "TOPUP TERM DEPOSIT",
      TRANSACTION_DESCRIPTION: "TOPUP TERM DEPOSIT",
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
